'use strict'

import * as types from './constants/mutation-types'
import * as stateKeys from './constants/state-keys'

export default {
  [types.UPDATE_EVENTS_JSON_LOADED] (state, payload) {
    state[stateKeys.IS_EVENTS_JSON_LOADED] = payload
  },
  [types.UPDATE_EVENTS_JSON] (state, payload) {
    state[stateKeys.EVENTS_JSON] = payload
  }
}
